var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[_c('a',{attrs:{"href":'https://www.google.com/maps/search/?api=1&output=embed&query='+_vm.data.centerLat+','+_vm.data.centerLng,"target":"_blank"}},[_vm._v(_vm._s(_vm.data.centerLat+','+_vm.data.centerLng))])])
}
var staticRenderFns = []

export { render, staticRenderFns }